import {ErrorWrapper, ResponseWrapper} from './util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'

class RoomShareNoteService extends RoomBaseApiService {
  constructor(props) {
    super(props)
  }

  async getRoomShareNoteInfo (roomGroupId) {
    try {
      const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/shareNote?roomGroupId=${roomGroupId||''}`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getRoomShareNoteInfoList () {
    try {
      const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/shareNotes`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getRoomShareNoteLogList () {
    try {
      const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/shareNote/logs`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async getRoomShareNoteLogData ({noteId}) {
    try {
      const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/shareNote/log/${noteId}`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeNote({roomGroupId, noteId}) {
    try {
      const response = await this.request({ auth: true }).post(
          `/api/v3/room/${this.getRoomId()}/shareNote/changeNote`,
          {roomGroupId, noteId}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getCheckpoint({roomGroupId}) {
    try {
      const response = await this.request({ auth: true }).get(
          `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/checkpoint`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async saveCheckpoint({roomGroupId, data}) {
    try {
      const response = await this.request({ auth: true }).post(
          `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/checkpoint`,
          data
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async removeCheckpoint({roomGroupId}) {
    try {
      const response = await this.request({ auth: true }).post(
          `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/checkpoint/clear`,
          {roomGroupId}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getHistory({roomGroupId, revisionId}) {
    try {
      const response = await this.request({ auth: true }).get(
          `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/history`,
          {params: {revisionId}}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async addHistory({roomGroupId, data}) {
    try {
      const response = await this.request({ auth: true }).post(
          `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/history`,
          data
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async removeHistory({roomGroupId}) {
    try {
      const response = await this.request({ auth: true }).post(
          `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/history/clear`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async sendOperation({roomGroupId, operation}) {
    try {
      const response = await this.request({ auth: true }).post(
        `/api/v3/room/${this.getRoomId()}/shareNote/${roomGroupId}/operation`,
        operation
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

}

export const roomShareNoteService = new RoomShareNoteService()
